import formPageLoadTrackMixin from './formPageLoadTrackMixin.js'

const JWEIXIN_URL = 'https://res.wx.qq.com/open/js/jweixin-1.6.2.js'
const DETECT_TIMEOUT_MS = 3000

let jweixinLoadPromise = null

/** 动态加载微信 JSSDK（web-view 内 detect 依赖 wx.miniProgram.getEnv） */
function loadJweixin() {
  if (typeof window.wx !== 'undefined' && window.wx.miniProgram) {
    return Promise.resolve()
  }
  if (jweixinLoadPromise) return jweixinLoadPromise

  jweixinLoadPromise = new Promise((resolve, reject) => {
    const existed = document.querySelector(`script[src="${JWEIXIN_URL}"]`)
    if (existed) {
      if (typeof window.wx !== 'undefined') {
        resolve()
        return
      }
      existed.addEventListener('load', () => resolve(), { once: true })
      existed.addEventListener('error', () => reject(new Error('jweixin load failed')), {
        once: true,
      })
      return
    }

    const script = document.createElement('script')
    script.src = JWEIXIN_URL
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('jweixin load failed'))
    ;(document.head || document.documentElement).appendChild(script)
  })

  return jweixinLoadPromise
}

function isWechatBrowser() {
  return /MicroMessenger/i.test(navigator.userAgent || '')
}

/** 是否在小程序 web-view 内打开 */
function isMiniProgramWebview() {
  return new Promise((resolve) => {
    if (!isWechatBrowser()) {
      resolve(false)
      return
    }

    let settled = false
    const done = (val) => {
      if (settled) return
      settled = true
      resolve(!!val)
    }

    const timer = setTimeout(() => done(false), DETECT_TIMEOUT_MS)

    const detect = () => {
      if (window.__wxjs_environment === 'miniprogram') {
        clearTimeout(timer)
        done(true)
        return true
      }

      if (
        window.wx &&
        window.wx.miniProgram &&
        typeof window.wx.miniProgram.getEnv === 'function'
      ) {
        window.wx.miniProgram.getEnv((res) => {
          clearTimeout(timer)
          done(res.miniprogram)
        })
        return true
      }

      return false
    }

    const run = () => {
      if (detect()) return

      const onBridgeReady = () => {
        if (!detect()) {
          clearTimeout(timer)
          done(false)
        }
      }

      if (window.WeixinJSBridge && window.WeixinJSBridge.invoke) {
        onBridgeReady()
      } else {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, { once: true })
      }
    }

    loadJweixin()
      .then(run)
      .catch(() => {
        clearTimeout(timer)
        done(false)
      })
  })
}

/** 表单页通用埋点（含 formPageLoadTrackMixin 的 100076/100077 加载耗时） */
export default {
  mixins: [formPageLoadTrackMixin],
  data() {
    return {
      isMini: false, // 是否在小程序webview内打开页面
    }
  },
  mounted() {
    this.handleFormPageTrack(100030)
    isMiniProgramWebview().then((isMini) => {
      if (isMini) {
        this.isMini = true
        this.handleFormPageTrack(100093)
      }
    })
  },
  methods: {
    /** 勾选协议 */
    handleTl5ThemeOneAgreementChange(val) {
      if (val) {
        this.handleFormPageTrack(100031)
      }
    },
    // 点击提交的相关埋点
    handleSubmitTrack() {
      if (this.checked) {
        this.handleFormPageTrack(100033)
      } else {
        this.handleFormPageTrack(100032)
      }
    },
  },
  beforeDestroy() {
    window.__TRACK_SCENE_KEY__ = ''
  },
}
